import { useQuery } from "@tanstack/react-query";
import { ssoApi } from "@repo/api";
import { ssoQueryKeys } from "../queryKeys";

export const useSsoConfig = () => {
  return useQuery({
    queryKey: ssoQueryKeys.config,
    queryFn: () => ssoApi.getConfig(),
  });
};
